import MyIcon from '@/components/MyIcon';
import { Tooltip } from 'antd';
const Regenerate = (props) => {
    const { side = 'web' } = props;
    return (
        <>
            <Tooltip zIndex={1} title={side === 'mobile' ? null : '重新生成'}>
                <span {...props}>
                    <MyIcon className="ai-action-icon" type="icon-zhongxinshengcheng"></MyIcon>
                </span>
            </Tooltip>
        </>
    );
};

export default Regenerate;
